import React from "react";
import { BillingCompanyContext } from "./BillingCompanyProvider.context";

import { getBillingCompanyFromStorage } from "./BillingCompanyProvider.storage";
import { IJobCustomer } from "../../redux/job_customer";

export function useBillingCompanyContext() {
  const context = React.useContext(BillingCompanyContext);

  if (!context) {
    throw new Error(
      "BillingCompanyContext: Context must be used inside AuthProvider",
    );
  }

  return context;
}

export const useBillingCompanyFromStorage = (): IJobCustomer => {
  const [billing_info] = React.useState<IJobCustomer>(() => {
    return getBillingCompanyFromStorage();
  });

  return billing_info;
};
